export const ACTIONS = {
  SET_ORDERS: 'courier/SET_ORDERS',
}

export default ACTIONS;
